import { EnergyCost } from './energyCost';

export class TotalEnergyCost {
	electric: EnergyCost;
	diesel: EnergyCost;
	gas: EnergyCost;
	electricComp: EnergyCost;
}
